<kendo-dialog
  *ngIf="visible"
  class="release-notes-dialog"
  [title]="getCurrentFeature()?.title || ''"
  [width]="700"
  [minWidth]="400"
  [maxHeight]="600"
  (close)="onClose()">

  <div class="release-notes-content" [style.background-color]="getCurrentFeature()?.featureBackgroundColor">
    <div *ngIf="getCurrentFeature() as currentFeature" class="feature-item">
      <div *ngIf="currentFeature.iconUrl" class="feature-icon-container" [style.background-color]="currentFeature.iconBackgroundColor">
        <img class="feature-icon" [src]="currentFeature.iconUrl" alt="{{ currentFeature.title }}" />
      </div>
      <div class="feature-content-scroll" style="overflow-y: auto;">
        <div class="feature-content" [innerHTML]="renderMarkdown(currentFeature.content)"></div>
      </div>
    </div>
  </div>

  <div *ngIf="getTotalFeatures() > 1" class="feature-counter" [style.background-color]="getCurrentFeature()?.featureBackgroundColor">
    <span *ngFor="let feature of features; let i = index"
          class="feature-bullet"
          [class.active]="i === currentFeatureIndex">
    </span>
  </div>

  <kendo-dialog-actions class="release-notes-actions">
    <div *ngIf="getTotalFeatures() > 1" class="navigation-actions">
      <span class="text-link close-link" (click)="onClose()">
        Închide
      </span>

      <div class="nav-buttons">
        <span
          *ngIf="!isFirstFeature()"
          class="text-link prev-link"
          (click)="prevFeature()">
          Înapoi
        </span>
        <button
          class="btn btn-primary next-btn"
          (click)="isLastFeature() ? onClose() : nextFeature()">
          {{ isLastFeature() ? 'Am înțeles' : 'Înainte' }}
        </button>
      </div>
    </div>

    <div *ngIf="getTotalFeatures() === 1" class="single-feature-actions">
      <button class="btn btn-primary" (click)="onClose()">
        Am înțeles
      </button>
    </div>
  </kendo-dialog-actions>
</kendo-dialog>